import { render, staticRenderFns } from "./TdEx.vue?vue&type=template&id=4412416e&scoped=true&"
import script from "./TdEx.vue?vue&type=script&lang=js&"
export * from "./TdEx.vue?vue&type=script&lang=js&"
import style0 from "./TdEx.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./TdEx.vue?vue&type=style&index=1&id=4412416e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4412416e",
  null
  
)

export default component.exports